import { STATUS_LABEL } from "@/lib/api";

const statusStyle = {
  proposal: "bg-slate-500/10 text-slate-700",
  pending: "bg-amber-500/10 text-amber-700",
  approved: "bg-emerald-500/10 text-emerald-700",
  rejected: "bg-red-500/10 text-red-700",
};

const colorStyle = {
  red: "bg-red-500/10 text-red-700",
  sky: "bg-sky-500/10 text-sky-700",
  amber: "bg-amber-500/10 text-amber-700",
  emerald: "bg-emerald-500/10 text-emerald-700",
  violet: "bg-violet-500/10 text-violet-700",
  slate: "bg-slate-500/10 text-slate-700",
};

const base = "inline-block rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wider";

export const StatusBadge = ({ status, testId }) => (
  <span data-testid={testId} className={`${base} ${statusStyle[status] || colorStyle.slate}`}>
    {STATUS_LABEL[status] || status}
  </span>
);

export const KindBadge = ({ type, testId }) => (
  <span data-testid={testId} className={`${base} ${colorStyle[type?.color] || colorStyle.slate}`}>
    {type?.label || type?.key}
  </span>
);
